import LoginDetails from './login';

export default LoginDetails;
